/**
 * MenuScreen — 主菜单
 */
import React from 'react';
import { Sparkles, Tv } from 'lucide-react';

interface MenuScreenProps {
  onStart: () => void;
}

const MenuScreen: React.FC<MenuScreenProps> = ({ onStart }) => {
  return (
    <div className="h-screen flex flex-col items-center justify-center p-4 text-center relative overflow-hidden bg-gradient-to-b from-cream to-coral-100">
      <div className="z-10 relative max-w-lg">
        <h1 className="text-4xl md:text-5xl font-black mb-2 text-transparent bg-clip-text bg-gradient-to-r from-coral-500 to-amber-accent flex items-center justify-center gap-2">
          <Sparkles size={24} className="text-amber-accent" />
          赛博红娘
          <Sparkles size={24} className="text-amber-accent" />
        </h1>
        <p className="text-xs text-[#9CA3AF] mb-1">这也配？</p>
        <p className="text-[#6B7280] mb-12 max-w-sm mx-auto text-sm leading-relaxed">
          扮演"上帝红娘"，用锦囊卡牌操控三幕式相亲大戏——<br />
          从亲友初筛到二人世界，再到关系考验。
        </p>

        <button
          onClick={onStart}
          className="px-8 py-4 rounded-full bg-gradient-to-r from-coral-500 to-amber-accent hover:from-coral-700 hover:to-coral-500 text-white font-bold text-xl tracking-wider shadow-lg transition-all hover:shadow-xl flex items-center justify-center gap-2 mx-auto"
        >
          <Tv size={20} />
          开始创建角色
        </button>
      </div>

      <div className="absolute bottom-4 text-xs text-[#9CA3AF]">
        Powered by Wortou AI
      </div>
    </div>
  );
};

export default MenuScreen;
